import React from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
// Shown only while the list loads or when it can't be read: the owner is
// always listed otherwise.
const TeamEmptyState = ({ classes }) => {
  return (
    <div className={classes.root}>
      <Typography className={classes.description}>No members yet.</Typography>
    </div>
  )
}

export default withStyles(styles)(TeamEmptyState)
